import { createContainerComponent, createDivOverlayComponent, createLeafComponent } from './component.js';
import { createControlHook } from './control.js';
import { createElementHook, createElementObject } from './element.js';
import { createLayerHook } from './layer.js';
import { createDivOverlayHook } from './div-overlay.js';
import { createPathHook } from './path.js';
export function createControlComponent(createInstance) {
  function createElement(props, context) {
    return createElementObject(createInstance(props), context);
  }
  var useElement = createElementHook(createElement);
  var useControl = createControlHook(useElement);
  return createLeafComponent(useControl);
}
export function createLayerComponent(createElement, updateElement) {
  var useElement = createElementHook(createElement, updateElement);
  var useLayer = createLayerHook(useElement);
  return createContainerComponent(useLayer);
}
export function createOverlayComponent(createElement, useLifecycle) {
  var useElement = createElementHook(createElement);
  var useOverlay = createDivOverlayHook(useElement, useLifecycle);
  return createDivOverlayComponent(useOverlay);
}
export function createPathComponent(createElement, updateElement) {
  var useElement = createElementHook(createElement, updateElement);
  var usePath = createPathHook(useElement);
  return createContainerComponent(usePath);
}
export function createTileLayerComponent(createElement, updateElement) {
  var useElement = createElementHook(createElement, updateElement);
  var useLayer = createLayerHook(useElement);
  return createLeafComponent(useLayer);
}